// Webpack Imports
import "bootstrap";

(function ($) {
  "use strict";

  // JQuery fallback: add title attribute from placeholder
  $("input, textarea").attr("title", function () {
    return $(this).attr("placeholder");
  });

  // Focus Search if Searchform is empty
  $(".search-form").on("submit", function (e) {
    var search = $("#s");
    if (search.val().length < 1) {
      e.preventDefault();
      search.focus();
    }
  });
})(jQuery);

var mapMenuInteraction = function ($this, $state) {
	if($.imageMapProInitialized){
		let classes = $this.attr("class").split(" ");
		for (let i = 0; i < classes.length; i++) {
		  if (classes[i].indexOf("spot-") != -1) {
			if ($state === "mouseleave") {
			  $.imageMapProHideTooltip("Floridsdorf", classes[i]);
			  $("#" + classes[i] + " img").removeAttr("style");
			} else if ($state === "mouseover") {
			  $("#" + classes[i] + " img").css("transform", "scale(2)");
			  $.imageMapProOpenTooltip("Floridsdorf", classes[i]);
			}
		  }
		}
	}
};

$(document).ready(function () {
  $("[class*='spot-']").mouseover(function () {
    mapMenuInteraction($(this), "mouseover");
  });
  $("[class*='spot-']").mouseleave(function () {
    mapMenuInteraction($(this), "mouseleave");
  });
});
